import { render, staticRenderFns } from "./OptionsAccordion.vue?vue&type=template&id=035479ba&scoped=true"
import script from "./OptionsAccordion.vue?vue&type=script&lang=js"
export * from "./OptionsAccordion.vue?vue&type=script&lang=js"
import style0 from "./OptionsAccordion.vue?vue&type=style&index=0&id=035479ba&prod&lang=scss&scoped=true"
import style1 from "./OptionsAccordion.vue?vue&type=style&index=1&id=035479ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035479ba",
  null
  
)

export default component.exports